import * as React from 'react';
import { inject, observer } from 'mobx-react';
import MeetingModal from '@/models/meeting';
import Style from './index.less';
import RTCInstance from '@/models/rtc';
import { getAvatarStr } from '@/utils/common';
import { useNickName } from '@/components/NickName';

const defaultImage = require('@/assets/default_blue_avatar.png');

// 电话或者话机设备
const showAvatarDeviceType = [100, 101, 102, 103];

export type AvatarType = 'micOn' | 'micOff' | 'cover' | 'speaking';
export interface AvatarProps {
  avatarId?: number;
  yxuid?: string;
  url?: string;
  size: number;
  type: AvatarType;
  meeting?: MeetingModal;
  style?: any;
  className?: string;
  imageSize?: number;
  rtc?: RTCInstance;
  name: string;
  deviceType?: number;
}

const Avatar: React.FC<AvatarProps> = inject(({ store }) => {
  return {
    meeting: store.meeting,
    rtc: store.rtc,
  };
})(
  observer(props => {
    const { size, style, className, name, url, deviceType, yxuid } = props;
    const [avatar, setAvatar] = React.useState<string>('');
    const [showName, setShowName] = React.useState<boolean>(true);

    const returnName = useNickName({ yxUid: yxuid, defaultName: name });

    React.useEffect(() => {
      if (url && deviceType && showAvatarDeviceType.includes(deviceType)) {
        setAvatar(url);
        setShowName(false);
      } else {
        const str = getAvatarStr((returnName || '').trim());
        setAvatar(str);
      }
    }, [returnName, url]);

    const [errImage, handleImageErrored] = React.useState('');

    const fontSize = React.useMemo(() => {
      if (name && /^[A-Z]$/.test(avatar)) {
        return (332 / 800) * size;
      }
      return (284 / 800) * size;
    }, [name, size, avatar]);

    return (
      <div
        className={`${Style['avatar-wrap']} ${className}`}
        style={{ width: `${size}px`, height: `${size}px`, fontSize: `${fontSize > 12 ? fontSize : 12}px`, ...style }}
      >
        {returnName && showName ? (
          <span
            style={
              fontSize > 12
                ? {}
                : {
                    transform: `scale(${fontSize / 12})`,
                  }
            }
          >
            {avatar}
          </span>
        ) : (
          <img
            src={errImage || avatar}
            onError={() => {
              handleImageErrored(defaultImage);
            }}
            alt=""
          />
        )}
      </div>
    );
  }),
);

export default Avatar;
